export const SOCKET_EVENTS = {
	error: 'error',
	success: 'success',
	connect: 'connect',
	disconnect: 'disconnect',
	setProfile: 'set-profile',
	setMyClients: 'set-my-clients',
	setMySelectedClient: 'set-my-selected-client',
	setMyCodes: 'set-my-codes',
	newCode: 'new-code',
	newClient: 'new-client',
	newBalance: 'new-balance',
	updateClient: 'update-client',
	updateBalance: 'update-balance',
	myClientsSearchResult: 'my-clients-search-result',
	setSelectedClient: 'set-selected-client',
	setCodes: 'set-codes',
	setBalances: 'set-balances',
	setMessages: 'set-messages',
	setActions: 'set-actions',
	setClientApps: 'set-client-apps',
	newAction: 'new-action',
	updateAction: 'update-action',
	newMessage: 'new-message',
	addClients: 'add-clients',
	addBalances: 'add-balances',
	addCards: 'add-cards',
	addPhones: 'add-phones',
	onlineCount: 'online-count',
	subscribeBuild: 'subscribe-build',
	unsubscribeBuild: 'unsubscribe-build',
	buildProgress: 'build-progress',
	buildLogLine: 'build-log-line',
	buildLogHistory: 'build-log-history',
	buildComplete: 'build-complete',
} as const;
